import React, { useEffect, useState } from "react";
import SearchBar from "../Main/searchBar";
import { Link, useParams, useNavigate } from "react-router-dom";
import { ReactComponent as BackIcon } from "../../Assets/Categories/BackIcon.svg";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import { listFranchiseBuilders } from "../../Redux/Actions/franchiseAction";
import { Pagination } from "antd";
import "./assignBuilder.css";

const AssignBuilder = () => {
  const { id } = useParams(); // franchise_id from URL param
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [builderList, setBuilderList] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [isLoadingBuilders, setIsLoadingBuilders] = useState(false);

  const cleanBuilderData = (builders) =>
    builders.map((b) => ({
      _id: b._id,
      builder_id: b.builder_id,
      brand_name: b.brand_name,
      primary_contact_number: b.primary_contact_number,
      primary_country_code: b.primary_country_code,
      primary_email: b.primary_email,
      account_status: b.account_status,
      created_at: b.created_at,
    }));

  // Fetch builder list using redux action
  const fetchBuilderList = async (page, pageSize) => {
    if (!id) {
      toast.error("Invalid franchise ID");
      return;
    }
    setIsLoadingBuilders(true);
    try {
      // API expects franchise_id as path param, page & limit in body
      const res = await dispatch(listFranchiseBuilders(page, pageSize, id));
      if (res?.statusCode === 200 && Array.isArray(res.data)) {
        setBuilderList(cleanBuilderData(res.data));
        setPagination({
          current: page,
          pageSize,
          total: res.total || 0,
        });
      } else {
        setBuilderList([]);
        setPagination({ current: 1, pageSize, total: 0 });
        toast("No builders assigned to this franchise");
      }
    } catch {
      toast.error("Failed to fetch builders");
    } finally {
      setIsLoadingBuilders(false);
    }
  };

  useEffect(() => {
    fetchBuilderList(pagination.current, pagination.pageSize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  // Navigate to assign builder form page with builderId and franchiseId
  const navigateToAssignForm = (builderId, brandName) => {
    navigate("/franchise/form-assign-builder", {
      state: { builderId, brandName, franchiseId: id },
    });
  };

  const formatDate = (dateString) => {
    if (!dateString) return "No Data";
    const options = {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  return (
    <div className="grid-container">
      <div
        className="padding-20"
        style={{ gridColumn: "3/8", marginBottom: 20 }}
      >
        <SearchBar style={{ width: "max-content" }} />
      </div>

      <div className="back-icon-container">
        <div className="back-icon-left">
          <Link to="/franchise">
            <BackIcon style={{ cursor: "pointer", width: 80, height: 80 }} />
          </Link>
          <h3 style={{ margin: 0, fontWeight: 600, color: "#181E2E" }}>
            Builders List
          </h3>
        </div>

        <Link
          to={`/franchise/assign-builder-list/${id}`}
          className="assign-builder-link"
        >
          Assigned Builder List
        </Link>
      </div>

      <div className="overall-container">
        <div
          className={`builder-list-wrapper ${
            builderList.length === 0 && !isLoadingBuilders ? "centered" : ""
          }`}
        >
          {isLoadingBuilders ? (
            <div className="loader">Loading builders...</div>
          ) : builderList.length > 0 ? (
            <>
              <table className="builder-table">
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Builder ID</th>
                    <th>Brand Name</th>
                    <th>Contact Number</th>
                    <th>Email</th>
                    <th>Created At</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {builderList.map((builder, index) => (
                    <tr key={builder._id}>
                      <td>
                        {(pagination.current - 1) * pagination.pageSize +
                          index +
                          1}
                      </td>

                      <td>{builder.builder_id ?? "No Data"}</td>
                      <td>{builder.brand_name ?? "No Data"}</td>
                      <td>
                        {builder.primary_country_code ?? ""}{" "}
                        {builder.primary_contact_number ?? "No Data"}
                      </td>
                      <td>{builder.primary_email ?? "No Data"}</td>
                      <td>{formatDate(builder.created_at)}</td>
                      <td>
                        <button
                          onClick={() =>
                            navigateToAssignForm(
                              builder._id,
                              builder.brand_name
                            )
                          }
                        >
                          Assign
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <Pagination
                current={pagination.current}
                pageSize={pagination.pageSize}
                total={pagination.total}
                showSizeChanger
                pageSizeOptions={["5", "10", "15", "20"]}
                onChange={(page, pageSize) => {
                  setPagination({ current: page, pageSize, total: pagination.total });
                  fetchBuilderList(page, pageSize);
                }}
                style={{ marginTop: 20, textAlign: "center" }}
              />
            </>
          ) : (
            <div
              style={{
                textAlign: "center",
                fontSize: 18,
                color: "rgba(255,255,255,0.7)",
                padding: 30,
              }}
            >
              No builders assigned to this franchise.
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AssignBuilder;
